import { Button, Flex, Input, useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { useState } from "react";
import { ContractTaskDto, UpdateTaskRequest } from "../../../../../../autogen/bff-api";
import { useApiError } from "../../../../../../common/errors/useApiError";
import { useSaveNow } from "../../../../../../common/editing/save-coordinator";
import { contractTaskEditorId } from "../useContractTaskEditor";

interface Props {
  task: ContractTaskDto;
  onEditComleted: () => void;
  onCancel: () => void;
}

export const EditTitle = ({ task, onEditComleted, onCancel }: Props) => {
  const [text, setText] = useState(task.title);
  const [isLoading, setIsLoading] = useState(false);
  const { saveNow } = useSaveNow<ContractTaskDto, UpdateTaskRequest>(contractTaskEditorId(task.id));
  const toast = useToast();
  const displayer = useApiError();
  return (
    <Flex flexDirection={"column"} w="100%" mt="10px">
      <Input id="edit-title-input" w="100%" type="text" value={text} onChange={(e) => setText(e.target.value)} />
      <Flex mt="10px">
        <Button
          id="save-title-button"
          variant={"solid"}
          colorScheme="teal"
          size="xs"
          isLoading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            try {
              await saveNow({
                title: text,
              });
              setIsLoading(false);
              onEditComleted();
            } catch (e) {
              setIsLoading(false);
              toast({
                title: t("Could not edit title"),
                description: displayer.message(e),
                status: "error",
              });
            }
          }}
        >
          {t("Save")}
        </Button>
        <Button variant={"solid"} colorScheme="gray" size="xs" ml="5px" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </Flex>
    </Flex>
  );
};
